import React from "react";
import { Link } from "react-router-dom";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import Seo from "../components/Seo";
import { SERVICES } from "../lib/services";

const SITE = "https://riznwash.com";

export default function ServicesIndex() {
  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "RIZ N WASH", item: SITE },
        { "@type": "ListItem", position: 2, name: "Services", item: `${SITE}/services` },
      ],
    },
    {
      "@context": "https://schema.org",
      "@type": "ItemList",
      name: "RIZ N WASH services in Gurugram",
      itemListElement: SERVICES.map((s, i) => ({
        "@type": "ListItem",
        position: i + 1,
        url: `${SITE}/services/${s.slug}`,
        name: s.name,
      })),
    },
  ];

  return (
    <div className="min-h-screen bg-rw-bg text-rw-ink" data-testid="services-index">
      <Seo
        title="Services · Laundry, Dry Cleaning, Shoe Care in Gurugram"
        description="Every RIZ N WASH service in Gurugram — wash & fold, dry cleaning, sneaker cleaning, curtains, duvets. Free pickup, transparent pricing, 24–48 hour turnaround."
        path="/services"
        jsonLd={jsonLd}
      />
      <Nav />
      <section className="max-w-6xl mx-auto px-6 md:px-10 pt-12 md:pt-24 pb-8">
        <div className="overline mb-3">Services</div>
        <h1 className="font-display font-light text-4xl md:text-6xl tracking-tight leading-[1.05]">
          Everything we clean, <em className="italic text-rw-blue not-italic">under one roof</em>.
        </h1>
        <p className="mt-6 text-rw-ink2 text-lg max-w-2xl leading-relaxed">
          Pick a service to see how we do it, what it costs, and how fast we return it.
        </p>
      </section>
      <section className="max-w-6xl mx-auto px-6 md:px-10 pb-24">
        <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {SERVICES.map((s) => (
            <li key={s.slug}>
              <Link
                to={`/services/${s.slug}`}
                data-testid={`service-card-${s.slug}`}
                className="group block rounded-2xl overflow-hidden border border-rw-ink/10 bg-rw-bg2 hover:border-rw-blue transition-all"
              >
                <div className="aspect-[4/3] overflow-hidden">
                  <img src={s.hero} alt={s.name} className="w-full h-full object-cover transition-transform group-hover:scale-105" />
                </div>
                <div className="p-6">
                  <div className="overline text-rw-ink3">From ₹{s.priceFrom} · {s.turnaround}</div>
                  <div className="font-display text-2xl mt-1 group-hover:text-rw-blue transition-colors">{s.name}</div>
                  <div className="mt-3 text-sm text-rw-ink2">{s.lede.slice(0, 120)}…</div>
                </div>
              </Link>
            </li>
          ))}
        </ul>
      </section>
      <Footer />
    </div>
  );
}
